/* eslint-disable radix */
/* eslint-disable react/no-unescaped-entities */
import React, { useMemo, useState } from 'react';
import { observer } from 'mobx-react';
import { Link } from 'react-router-dom';
import { ReactComponent as LockIcon } from 'Assets/svg/lock.svg';
import { ReactComponent as GetLeadsIcon } from 'Assets/svg/get-leads.svg';
// import { ReactComponent as InfoIcon } from 'Assets/svg/info-icon.svg';
import { ReactComponent as NewFilterIcon } from 'Assets/svg/new-filter-icon.svg';
import { ReactComponent as BookmarksIcon } from 'Assets/svg/bookmarks.svg';
import { ReactComponent as NewContactsImage } from 'Assets/svg/new-contacts.svg';
import { ReactComponent as NewClockIcon } from 'Assets/svg/clock-icon.svg';
import { ReactComponent as CrossIcon } from 'Assets/usageAnalytics/cross-icon.svg';
import userDetail from 'Stores/userDetail';
import * as CONSTANTS from 'Utils/constants';
import { advSearchState } from 'Stores/advSearch';
import CheckBox from 'Components/common/CheckBox';
import Select from 'Components/common/select';
import { confirmationPopupState } from 'Components/common/confirmationPopup';
import { warningPopupState } from 'Components/common/commonWarningPopup';
// import InputWithButton from 'Components/common/inputWithButton';
import Button from 'Components/common/Button';
import ToolTipWithIcon from 'Components/common/ToolTipWithIcon';
import LoadingWrapper from 'Components/common/loadingWrapper';
// import { personalisedOnboardingState } from 'Stores/personalisedOnboardingState';
import { Utils } from 'Utils/utils';
// import { commonUpgradePopupState } from 'Components/common/commonUpgradePopup';
import { addToListWithOptionsState } from './AddToListWithOptions';

const {
  PERSONALIED_ONBOARDING_FLOWS,
  MX_PERSONALISED_ONBOARDING_EVENTS,
  UPGRADE_TRIGGERS,
} = CONSTANTS;
const { EMAIL_CAMPAIGN_LIST } = PERSONALIED_ONBOARDING_FLOWS;
const {
  LB_GOAL_CURRENT_STEP_VALUE,
  LB_GOAL_COMPLETE,
} = MX_PERSONALISED_ONBOARDING_EVENTS;
const { EXPORT } = LB_GOAL_CURRENT_STEP_VALUE;

const ContactMiddleSection = observer(props => {
  const {
    setNewContactInDays,
    newContactInDays,
    savedSearchId,
    selectedTab,
  } = props;
  const [dropdownActionClick, setDropdownActionClick] = React.useState('');
  const [selectionClick, setSelectionClick] = React.useState(false);
  const [rangeBoxValue, setRangeBoxValue] = React.useState('');
  const [limitContactsPerCompany, setLimitContactsPerCompany] = React.useState({
    value: '',
  });
  const [showFilter, setShowFilter] = useState(false);

  const maxPurchaseLimit =
    advSearchState.searchResultCount > userDetail.userInfo.purchaseLimit
      ? userDetail.userInfo.purchaseLimit
      : advSearchState.searchResultCount;

  const { userInfo, featureFlags } = userDetail;

  const { LEAD_BUILDER = false, LIST_BUILDING = false, CRM_EXPORT = false } =
    featureFlags || {};

  const { MX_AS_EVENTS, EXPORT_SOURCE } = CONSTANTS;
  const { AS_LIMIT_CONTACT_PER_COMPANY } = MX_AS_EVENTS;

  const { ADVANCED_SEARCH } = EXPORT_SOURCE;

  const closeActionMask = () => {
    setDropdownActionClick('');
    setSelectionClick(false);
  };

  const addToListBtnClick = e => {
    if (
      advSearchState.bulkPurchaseIds.length > 0 ||
      advSearchState.bulkRangeCount > 0
    )
      if (Utils.checkIsEmailVerified(true)) {
        addToListWithOptionsState.setShowListPopup(true);
      }
  };

  const handleDropdownActionClick = (e, actionType) => {
    if (e) e.preventDefault();
    closeActionMask();
    setDropdownActionClick(actionType);
  };

  const setSelectionClicked = e => {
    setSelectionClick(!selectionClick);
  };

  const clearSelections = e => {
    if (e !== null) e.stopPropagation();
    advSearchState.clearAllSelection();
    advSearchState.updateSelectedBulkContactAll(true);
    closeActionMask();
  };

  const rangeSelection = () => {
    if (
      rangeBoxValue !== '' &&
      rangeBoxValue > 0 &&
      rangeBoxValue <= maxPurchaseLimit
    ) {
      advSearchState.selectHugeContacts(rangeBoxValue);
      setRangeBoxValue('');
      closeActionMask();
    }
  };

  const selectAllFromSearchResults = e => {
    if (e !== null) e.stopPropagation();
    if (advSearchState.searchResultCount > userDetail.userInfo.purchaseLimit) {
      // This use case not occurs in our current flow
      const emptyCbk = () => {};
      Utils.mixpanelTrack(CONSTANTS.MX_AS_EVENTS.AS_LIMIT_EXCEED_POPUP, {
        currentLimit: userDetail.userInfo.purchaseLimit,
        triedLimit: advSearchState.searchResultCount,
        btnSource: 'contactTab',
      });
      confirmationPopupState.setPopupValues({
        title: 'Limit Exceeded',
        content: `You can purchase a maximum of ${userDetail.userInfo.purchaseLimit} contacts in a single transaction.`,
        actionBtnText: 'OK',
        needCancelBtn: false,
        callback: emptyCbk,
      });
      confirmationPopupState.setShowPopup(true);
    } else {
      advSearchState.selectHugeContacts(advSearchState.searchResultCount, true);
    }
    closeActionMask();
  };

  const rangeValueChange = e => {
    if (e !== null) e.stopPropagation();

    if (
      e.currentTarget &&
      e.currentTarget.value &&
      parseInt(e.currentTarget.value) <= maxPurchaseLimit
    )
      setRangeBoxValue(parseInt(e.currentTarget.value));
    else if (e.currentTarget.value === '') setRangeBoxValue('');
    else setRangeBoxValue(rangeBoxValue);
  };

  const showUpgradePopup = event => {
    if (event !== undefined)
      event.currentTarget.classList.add('show-upgrade-popup');

    // eslint-disable-next-line no-undef
    const maskEle = document.getElementsByClassName('upgradePopupMask')[0];
    maskEle.classList.add('showMask');
  };

  const clearUpgradePopup = onMouseEnter => {
    if (onMouseEnter) {
      if (LIST_BUILDING === false)
        Utils.mixpanelTrack(CONSTANTS.MX_AS_EVENTS.AS_WEB_PAYWALL_VIEWED, {
          type: 'AS - Add to List (Get leads)',
        });
      if (LEAD_BUILDER === false)
        Utils.mixpanelTrack(CONSTANTS.MX_AS_EVENTS.AS_WEB_PAYWALL_VIEWED, {
          type: 'AS - LB Disabled',
        });
    }

    // eslint-disable-next-line no-undef
    const eleList = document.getElementsByClassName('show-upgrade-popup');
    if (eleList !== undefined && eleList.length > 0)
      for (let i = 0; i < eleList.length; i += 1)
        eleList[i].classList.remove('show-upgrade-popup');
    // eslint-disable-next-line no-undef
    const maskEle = document.getElementsByClassName('upgradePopupMask')[0];
    maskEle.classList.remove('showMask');
  };

  const showPricingPopup = (e, key) => {
    if (e !== null) e.stopPropagation();
    if (LEAD_BUILDER === false) Utils.upgradeNowClick('lead_builder');
    else Utils.upgradeNowClick('list_building');
  };

  const formatNumberWithText = (number, text = '', showContactText = true) => {
    return number !== undefined && number !== null ? (
      <>
        {Utils.usNumberFormat(number)}
        &nbsp;{text}
        {showContactText && <>{number > 1 ? 'contacts' : 'contact'}&nbsp;</>}
      </>
    ) : (
      ''
    );
  };

  const limitContactsPerCompanyAndPurchase = e => {
    const noOfContacts = limitContactsPerCompany.value;
    const limit = rangeBoxValue;
    setLimitContactsPerCompany({ value: '' });
    setRangeBoxValue('');

    if (Utils.checkIsEmailVerified()) {
      const { views, lbCredits } = userInfo;
      const isMemberCreditLimit =
        userDetail.userInfo.creditLimitEnabled &&
        !userDetail.userInfo.isEnterpriseAdmin &&
        userDetail.userInfo.remainingIndividualLbCredits !== -1 &&
        advSearchState.uniqueCompanyCount < lbCredits;
      const availCreditCount = Utils.isCreditBasedSubscription()
        ? isMemberCreditLimit
          ? userDetail.userInfo.remainingIndividualLbCredits
          : lbCredits
        : views;

      const limitAndListIdCallback = async ({
        listId,
        listName,
        callback,
        checkboxValues,
      }) => {
        const limitValue = rangeBoxValue || advSearchState.uniqueCompanyCount;
        const condition =
          checkboxValues.email && checkboxValues.phone
            ? limitValue > availCreditCount ||
              limitValue > userDetail.userInfo.phoneCreditsRemaining
            : checkboxValues.email
            ? limitValue > availCreditCount
            : checkboxValues.phone
            ? limitValue > userDetail.userInfo.phoneCreditsRemaining
            : false;

        if (condition) {
          Utils.mixpanelTrack(
            AS_LIMIT_CONTACT_PER_COMPANY.PURCHASE_VIEWS_EXCEEDED,
            {},
          );
          warningPopupState.setShowPopup({
            title: isMemberCreditLimit
              ? 'Credit Limit Reached'
              : 'Not Enough Credits',
            message:
              // eslint-disable-next-line quotes
              isMemberCreditLimit ? (
                <>
                  The list you have requested could not be processed. You do not
                  have sufficient credit limit to perform this transaction.
                  Please contact your administrator.
                </>
              ) : (
                <>
                  Unfortunately you don't have enough contact credits to
                  generate this list. Please revise the criteria or write to{' '}
                  <a href="mailto:support@adapt.io target=_blank">
                    support@adapt.io
                  </a>{' '}
                  to upgrade your plan.
                </>
              ),
            className: 'limit-contacts',
          });
          callback();
        } else {
          await advSearchState.purchaseContactAsync({
            listId,
            required: advSearchState.getRequiredPropertyForPurchase(
              checkboxValues,
            ),
            limitContactsPerCompany: true,
            limit,
            limitPerDomain: noOfContacts,
          });

          callback();
        }
      };
      addToListWithOptionsState.setAddToListOptions({
        saveAction: limitAndListIdCallback,
        isEmailMandatory: false,
      });
      addToListWithOptionsState.setShowListPopup(true);
      closeActionMask();
    }
  };

  const applySelection = () => {
    if (limitContactsPerCompany.value) limitContactsPerCompanyAndPurchase();
    else rangeSelection();
  };

  const isSavedSearchEmptyState =
    savedSearchId !== '' && advSearchState.searchResults.length === 0;

  const limitContactsPerCompanyOptions = useMemo(
    () =>
      Array.from({
        length:
          userDetail.userInfo?.memberSubscription?.limitContactPerCompanyMaxLimit || 3,
      }).map((...args) => {
        const index = args[1] + 1;
        return { label: String(index), value: index };
      }),
    [userDetail.userInfo.memberSubscription],
  );

  return advSearchState.searchResults.length > 0 || isSavedSearchEmptyState ? (
    <>
      {/* <LoadingWrapper show={advSearchState.resultLoading} /> */}
      <div
        className={`adv-leads-action${
          savedSearchId !== '' ? ' saved-search-updates' : ''
        }`}
      >
        <div
          className={`adv-contact-action-btn-wrap${
            advSearchState.bulkPurchaseIds.length > 0 ||
            advSearchState.bulkRangeCount > 0
              ? ' contact-selected'
              : ''
          }`}
        >
          <div
            className={`contact-action-btn selection-wrap${
              selectionClick ? ' clicked' : ''
            }${
              isSavedSearchEmptyState || advSearchState.resultLoading
                ? ' disable-action'
                : ''
            }`}
          >
            <div
              className={`box-wrap${
                advSearchState.allContactSelected ? ' selected' : ''
              }`}
              onClick={setSelectionClicked}
            >
              <div className="contact-chechk-box-wrap">
                <CheckBox
                  dymamicClass={
                    advSearchState.allContactSelected ? 'selected' : ''
                  }
                />
              </div>
              {(advSearchState.selectedAllContactAcrossPage ||
                advSearchState.selectedContactFromRange) && (
                <div className="selected-count">
                  &nbsp;
                  {formatNumberWithText(
                    advSearchState.bulkRangeCount,
                    '',
                    false,
                  )}
                  selected
                </div>
              )}
              {!advSearchState.selectedAllContactFromPage &&
                !advSearchState.selectedAllContactAcrossPage &&
                !advSearchState.selectedContactFromRange &&
                advSearchState.bulkPurchaseIds.length > 0 && (
                  <div className="selected-count">
                    &nbsp;
                    {formatNumberWithText(
                      advSearchState.bulkPurchaseIds.length,
                      '',
                      false,
                    )}
                    selected
                  </div>
                )}
              <i className="fa fa-angle-down dropdown-icon" />
            </div>
            <div className="drop-popup-box animatedFast animatedDropDown">
              <div className="list-action-item range-selection">
                <div className="label-with-input">
                  <div className="label-with-note">
                    <label htmlFor="range-value">
                      Select number of contacts
                    </label>
                    <i>({Utils.usNumberFormat(maxPurchaseLimit)} max)</i>
                  </div>
                  <input
                    onChange={rangeValueChange}
                    id="range-value"
                    min={1}
                    step={1}
                    max={maxPurchaseLimit}
                    value={rangeBoxValue}
                    type="number"
                  />
                </div>
                {LEAD_BUILDER && LIST_BUILDING && !Utils.isFreeTrialPlan() && (
                  <div className="label-with-input">
                    Max contacts per company{' '}
                    <Select
                      wrapperClassName="contact-limit-dropdown"
                      placeholder="select"
                      options={limitContactsPerCompanyOptions}
                      value={limitContactsPerCompany.value}
                      onChange={data => {
                        setLimitContactsPerCompany({
                          value: data,
                        });
                      }}
                    />
                  </div>
                )}
              </div>
              <div className="list-action-item apply-wrapper">
                <Button
                  click={applySelection}
                  btnText="Apply"
                  disabled={!rangeBoxValue}
                />
              </div>
              {(advSearchState.bulkRangeCount > 0 ||
                advSearchState.bulkPurchaseIds.length > 0) && (
                <div className="list-action-item clear-selection">
                  <Button click={clearSelections} btnText="Clear Selection" />
                </div>
              )}
            </div>
          </div>
          {/* <ContactExportComponent /> */}

          {LIST_BUILDING === false || LEAD_BUILDER === false ? (
            <div
              id="getContactBulkLB"
              className="contact-action-btn get-leads-btn blocked-wrap"
              onClick={showUpgradePopup}
            >
              <GetLeadsIcon className="svg-icon" />
              Add to list
              <div
                className="lock-wrap"
                onMouseEnter={e => clearUpgradePopup(true)}
                onMouseLeave={e => clearUpgradePopup(false)}
              >
                <LockIcon className="dropdown-icon plus-icon lock-icon" />
                <div className="phoneUpgrade filterLockUpgrade">
                  <div className="phoneUpgradeWrap">
                    <div className="up-text">
                      Upgrade to get multiple contacts
                    </div>

                    <div
                      onClick={e => showPricingPopup(e, 'Get Leads')}
                      className="locked-numbers-upgrade"
                    >
                      {Utils.getLockFilterBtnText()}
                    </div>
                  </div>
                </div>
              </div>
            </div>
          ) : (
            <div
              id="getContactBulkLB"
              className={`contact-action-btn get-leads-btn${
                advSearchState.bulkPurchaseIds.length > 0 ||
                advSearchState.bulkRangeCount > 0
                  ? ''
                  : ' btn-disabled'
              }`}
              onClick={addToListBtnClick}
            >
              <GetLeadsIcon className="svg-icon" />
              Add to list
            </div>
          )}
          <Link
            className="saved-searches-link"
            to={CONSTANTS.PAGE_PATH_MAP.CONTACT_SEARCH_SAVED_SEARCHES}
            onClick={() =>
              Utils.mixpanelTrack(
                CONSTANTS.MX_SAVED_SEARCH_EVENTS.AS_SAVED_SEARCHES_CLICKED,
                {
                  count: userDetail.contactSavedSearches.length,
                },
              )
            }
          >
            <BookmarksIcon />
            <span>{`Saved Searches${
              userDetail.contactSavedSearches.length > 0
                ? ` (${userDetail.contactSavedSearches.length})`
                : ''
            }`}</span>
          </Link>
          {Utils.isInternalAdminUser() && advSearchState.searchResultCount > 0 && (
            <div
              className={`contact-action-btn bulk-actions${
                dropdownActionClick === 'bulk' ? ' clicked' : ''
              }`}
              onClick={e => handleDropdownActionClick(e, 'bulk')}
            >
              Bulk Actions
              <i className="fa fa-angle-down dropdown-icon" />
              <div className="drop-popup-box">
                <div
                  className="list-action-item all-inactive"
                  onClick={e => advSearchState.inActivateContact(true)}
                >
                  {`Set All Inactive (${advSearchState.searchResults.length})`}
                </div>
                {advSearchState.bulkPurchaseIds.length > 0 && (
                  <div
                    className="list-action-item all-inactive"
                    onClick={e => advSearchState.inActivateContact()}
                  >
                    {`Set Selected Inactive (${advSearchState.bulkPurchaseIds.length})`}
                  </div>
                )}
                <div
                  className="list-action-item all-inactive"
                  onClick={e => advSearchState.deleteConatcts(true)}
                >
                  {`Delete All (${advSearchState.searchResults.length})`}
                </div>
                {advSearchState.bulkPurchaseIds.length > 0 && (
                  <div
                    className="list-action-item all-inactive"
                    onClick={e => advSearchState.deleteConatcts()}
                  >
                    {`Delete Selected (${advSearchState.bulkPurchaseIds.length})`}
                  </div>
                )}
              </div>
            </div>
          )}
          <div
            className={`bulk-action-mask${
              dropdownActionClick !== '' || selectionClick ? ' show-mask' : ''
            }`}
            onClick={closeActionMask}
          />
        </div>
        {advSearchState.searchResultCount > 0 && !advSearchState.resultLoading && (
          <div className="leads-count">
            {Utils.usNumberFormat(advSearchState.searchResultCount)}
            &nbsp;
            <span>{advSearchState.searchResultCount > 1 ? 'contacts' : 'contact'}</span>
            &nbsp;from&nbsp;
            {advSearchState.companyCountLoading ? (
              <div className="company-count-loader">
                <LoadingWrapper show />
              </div>
            ) : (
              advSearchState.uniqueCompanyCount > 0 && (
                <>
                  {Utils.usNumberFormatForCompanyCount(
                    advSearchState.uniqueCompanyCount,
                  )}
                  &nbsp;
                  {advSearchState.uniqueCompanyCount > 1
                    ? 'companies'
                    : 'company'}
                </>
              )
            )}
          </div>
        )}
        {savedSearchId !== '' && userDetail.isContactUpdatesEnabled && (
          <div className="tabs">
            <div
              className={`tab${selectedTab === 1 ? ' active' : ''}`}
              onClick={() => {
                Utils.mixpanelTrack(
                  CONSTANTS.MX_SAVED_SEARCH_EVENTS.ALL_CONTACTS_TAB_CLICK,
                  {
                    id: savedSearchId,
                  },
                );
                advSearchState.removeAppliedFilterFromGroup(
                  'createdInLastNoOfDays',
                  newContactInDays,
                );
              }}
            >
              <span className="tab-text">All Contacts</span>
            </div>

            <div
              className={`tab${selectedTab === 2 ? ' active' : ''}`}
              onClick={() => {
                if (newContactInDays === null || selectedTab === 2)
                  setShowFilter(true);
                else
                  advSearchState.setAppliedFilters(
                    'createdInLastNoOfDays',
                    newContactInDays,
                  );
              }}
            >
              <span className="tab-text">New Contacts</span>
              <NewFilterIcon className="filter" />
              {showFilter && (
                <>
                  <div
                    className="filter-mask"
                    onClick={e => {
                      e.stopPropagation();
                      setShowFilter(false);
                    }}
                  />
                  <div
                    className="filter-popup"
                    onClick={e => e.stopPropagation()}
                  >
                    <div className="sharp-point" />
                    <div className="wrapper">
                      <CrossIcon
                        className="cross-icon"
                        onClick={() => setShowFilter(false)}
                      />
                      <NewContactsImage className="new-contacts-image" />
                      <div className="message">
                        We have added new contacts for this Saved Search. Check
                        it out!
                      </div>

                      <div className="filter-section">
                        <div className="title">Choose timeframe</div>
                        <div
                          className={`filter-item${
                            advSearchState.appliedFilterPostData
                              .createdInLastNoOfDays === 7
                              ? ' selected'
                              : ''
                          }`}
                          onClick={() => {
                            Utils.mixpanelTrack(
                              CONSTANTS.MX_SAVED_SEARCH_EVENTS
                                .NEW_CONTACTS_TAB_CLICK,
                              {
                                noOfDays: 7,
                                id: savedSearchId,
                              },
                            );
                            setShowFilter(false);
                            advSearchState.setAppliedFilters(
                              'createdInLastNoOfDays',
                              7,
                            );
                            setNewContactInDays(7);
                          }}
                        >
                          <NewClockIcon className="clock-icon" />
                          <span>Last 7 Days</span>
                        </div>
                        <div
                          className={`filter-item${
                            advSearchState.appliedFilterPostData
                              .createdInLastNoOfDays === 30
                              ? ' selected'
                              : ''
                          }`}
                          onClick={() => {
                            Utils.mixpanelTrack(
                              CONSTANTS.MX_SAVED_SEARCH_EVENTS
                                .NEW_CONTACTS_TAB_CLICK,
                              {
                                noOfDays: 30,
                                id: savedSearchId,
                              },
                            );
                            setShowFilter(false);
                            advSearchState.setAppliedFilters(
                              'createdInLastNoOfDays',
                              30,
                            );
                            setNewContactInDays(30);
                          }}
                        >
                          <NewClockIcon className="clock-icon" />
                          <span>Last 30 Days</span>
                        </div>
                      </div>
                    </div>
                  </div>
                </>
              )}
            </div>
          </div>
        )}
      </div>
    </>
  ) : (
    ''
  );
});

export default ContactMiddleSection;
export { ContactMiddleSection };
